import { useContext } from 'react';
import { type BiLogger } from './types';
import { BiLoggerContext } from './BiLoggerProvider';

export const useBiLogger = (): BiLogger => {
  const biLogger = useContext(BiLoggerContext);

  return biLogger;
};
